import Modal from 'react-modal';
import { ComponentProps, FC } from 'react';
import { useModalScrollBehaviour } from '@/hooks/useModalScrollBehaviour';

export const ModalWrapper: FC<ComponentProps<typeof Modal>> = ({
  children,
  className,
  overlayClassName,
  isOpen,
  shouldCloseOnOverlayClick = true,
  ...rest
}) => {
  useModalScrollBehaviour(isOpen);
  return (
    <Modal
      className={[
        className,
        'h-[645px] w-[800px] fixed flex flex-col items-start p-12 gap-5 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-2xl',
      ].join(' ')}
      overlayClassName={[
        'fixed inset-0 w-full h-full bg-[rgba(33,33,33,0.6)] backdrop-blur-[1px] z-[1000]',
        overlayClassName,
      ].join(' ')}
      isOpen={isOpen}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      {...rest}
    >
      {isOpen ? children : null}
    </Modal>
  );
};
